import React, { useState, useRef, useEffect, useCallback } from "react";
import ReactDOM from "react-dom";
import { MiscReason } from "../../../utils/constant.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { modalEventListener } from "../../../utils/ModalEventListener";
import SingleSelectDropDown from "../../../layouts/SingleSelectDropDown";
import { ToastContainer, toast } from "react-toastify";
import { axios_instance } from "../../../api/axios_instance";
import ModalWrapper from "../../../layouts/ModalWrapper.jsx";

const AddBankPaymentModal = ({
  closeAddBankPaymentModal,
  dis_id,
  lead_id,
  addPayment,
  showAddBankPaymentModal,
}) => {
  const initialState = {
    showMiscReason: false,
    date: "",
    bank: "",
    reason: "",
    amount: "",
    receivingBanks: [],
    receivingBankLength: 0,
  };
  const [state, setState] = useState(initialState);
  const [disabled, setDisabled] = useState(false);
  const [errorMsgState, setErrorMsgState] = useState("");
  const [receivingBankLength, setreceivingBankLength] = useState(0);
  const ref = useRef();

  const handlecloseAddBankPaymentModal = () => {
    setState((prevState) => ({
      ...initialState,
      receivingBanks: prevState.receivingBanks,
    }));
    closeAddBankPaymentModal();
  };

  const fetchReceivingBanks = useCallback(async () => {
    try {
      const response = await axios_instance({
        url: "/dts/getReceivingBanks",
        method: "GET",
      });
      const result = response.data;
      console.log(result.data);
      if (result.status === true) {
        setState((prevState) => ({
          ...prevState,
          receivingBanks: result.data,
        }));
        setreceivingBankLength(1);
      }
    } catch (error) {
      console.error("Error fetching receiving banks:", error);
      toast.error("Failed to load receiving banks");
    }
  }, [receivingBankLength]);

  useEffect(() => {
    if (showAddBankPaymentModal && receivingBankLength === 0) {
      fetchReceivingBanks();
    }
    return modalEventListener(ref, handlecloseAddBankPaymentModal, true);
  }, [
    showAddBankPaymentModal,
    handlecloseAddBankPaymentModal,
    fetchReceivingBanks,
  ]);

  const addBankSummary = async (proceed = false) => {
    try {
      toast.dismiss();
      setDisabled(true);

      // Form validation
      if (!proceed) {
        if (!state.bank) {
          setDisabled(false);
          return toast.error("Please enter receiving bank", {
            theme: "colored",
          });
        }
        if (state.showMiscReason && !state.reason) {
          setDisabled(false);
          return toast.error("Please enter misc. reason", { theme: "colored" });
        }
        if (!state.amount) {
          setDisabled(false);
          return toast.error("Please enter amount", { theme: "colored" });
        }
        if (parseInt(state.amount) < 0) {
          setDisabled(false);
          return toast.error("Payment amount cannot be negative", {
            theme: "colored",
          });
        }
        if (!state.date) {
          setDisabled(false);
          return toast.error("Please enter date", { theme: "colored" });
        }
        const utrNarration = (state.utr_narration || "").trim();

        if (!utrNarration) {
          setDisabled(false);
          return toast.error("Please enter UTR/Narration", {
            theme: "colored",
          });
        }

        const transactionId = (state.transaction_id || "").trim();
        if (!transactionId) {
          setDisabled(false);
          return toast.error("Please enter Transaction ID", {
            theme: "colored",
          });
        }
      }

      // Payload creation
      const payload = {
        lead_id,
        dis_id,
        bank_payment_amount: state.amount,
        added_date: state.date,
        amount_check: errorMsgState ? "no" : "yes",
        receiving_bank: state.bank,
        misc_receipt: state.showMiscReason ? 1 : 0,
        misc_reason: state.reason,
        proceed,
        utr_narration: state.utr_narration,
        transaction_id: state.transaction_id,
      };

      // API request
      const addResult = await axios_instance({
        url: "/dts/addBankSummary",
        method: "POST",
        data: payload,
      });

      await addPayment(addResult.data.addedPayment);
      toast.success("Details have been saved successfully.", {
        theme: "colored",
      });
    } catch (error) {
      if (error?.response?.status === 409 && !proceed) {
        setDisabled(false);
        const userConfirmation = window.confirm(
          `${error?.response?.data?.addedPayment?.message}. Want to proceed?`
        );
        if (userConfirmation) {
          try {
            await addBankSummary(true);
          } catch (proceedError) {
            toast.error(
              proceedError?.response?.data?.err || "An error occurred",
              { theme: "colored" }
            );
          }
        }
      } else {
        toast.error(error?.response?.data?.err || "An error occurred", {
          theme: "colored",
        });
        setErrorMsgState("");
        setDisabled(false); // Ensure disabled state is reset
      }
    }
  };

  const handleDateChange = (value, name, e) => {
    setState({ ...state, [name]: value });
    e.stopPropagation();
  };

  return ReactDOM.createPortal(
    <ModalWrapper
      show={showAddBankPaymentModal}
      onClose={handlecloseAddBankPaymentModal}
    >
      <div className="modal-wrapper">
        <ToastContainer
          closeOnClick={false}
          draggable={false}
          closeButton={false}
        />
        <div className="addbankpayment-modal-content" ref={ref}>
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={handlecloseAddBankPaymentModal}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 className="modal-title">Bank Payment Details</h4>
          </div>
          <div className="modal-body clearfix">
            <div className="form-group">
              <label>Receiving Bank</label>
              <SingleSelectDropDown
                dataArr={
                  Array.isArray(state.receivingBanks)
                    ? state.receivingBanks
                    : []
                }
                handleChange={(e) =>
                  setState({ ...state, bank: e.target.value })
                }
                name="receiving_bank"
                value={state.bank}
              />
            </div>
            <div className="form-group">
              <label>Misc. Receipt</label>
              <div
                className="btn-group toggle-option misc_grp"
                data-toggle="buttons"
              >
                <label
                  className={`btn tog-btn tog-positive misc_grp ${
                    state.showMiscReason ? "active" : ""
                  }`}
                  onClick={() => setState({ ...state, showMiscReason: true })}
                >
                  <input
                    type="radio"
                    name="misc_receipt"
                    className="misc_receipt"
                    value="1"
                  />
                  Yes
                </label>
                <label
                  className={`btn tog-btn tog-negative misc_grp ${
                    state.showMiscReason ? "" : "active"
                  }`}
                  onClick={() => setState({ ...state, showMiscReason: false })}
                >
                  <input
                    type="radio"
                    name="misc_receipt"
                    className="misc_receipt"
                    value="0"
                  />{" "}
                  No
                </label>
              </div>
            </div>
            {state.showMiscReason && (
              <div className="form-group misc-drp">
                <label>Misc. Reason</label>
                <SingleSelectDropDown
                  dataArr={MiscReason}
                  handleChange={(e) =>
                    setState({ ...state, reason: e.target.value })
                  }
                  name="misc_reason"
                  value={state.reason}
                />
              </div>
            )}

            <div className="form-group">
              <label>Amount</label>
              <input
                type="text"
                value={state.amount}
                id="bank_payment_amount"
                name="bank_payment_amount"
                className="form-control count-only-input"
                placeholder="Enter Amount"
                onChange={(e) => setState({ ...state, amount: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>Date</label>
              <div
                className="input-append date"
                id="dp-bank-summary"
                data-date-format="dd-mm-yyyy"
              >
                <DatePicker
                  name="date"
                  selected={state.date}
                  maxDate={new Date()}
                  onChange={(date, e) => handleDateChange(date, "date", e)}
                  placeholderText="Select Date"
                  className="span2 form-control add-on calender filter-tb date-bg_input"
                  dateFormat="dd-MM-yyyy"
                />
              </div>
            </div>
            <div className="form-group">
              <label>UTR/Narration</label>
              <input
                type="text"
                value={state.utr_narration}
                id="bank_payment_utr"
                name="bank_payment_utr"
                className="form-control count-only-input"
                placeholder="Enter UTR/Narration"
                onChange={(e) =>
                  setState({ ...state, utr_narration: e.target.value })
                }
              />
            </div>
            <div className="form-group">
              <label>Transaction ID</label>
              <input
                type="text"
                value={state.transaction_id || ""}
                id="bank_payment_transaction_id"
                name="bank_payment_transaction_id"
                className="form-control count-only-input"
                placeholder="Enter Transaction ID"
                onChange={(e) =>
                  setState({ ...state, transaction_id: e.target.value })
                }
              />
            </div>
            {errorMsgState ? (
              <div className="errorTxt" id="error_bank_summary">
                {errorMsgState}
              </div>
            ) : (
              <></>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn rc-btn_rset pad-L20 pad-R20"
              data-dismiss="modal"
              onClick={handlecloseAddBankPaymentModal}
            >
              Cancel
            </button>
            <button
              type="button"
              disabled={disabled}
              className="btn rc-btn_primary pad-L20 pad-R20"
              onClick={() => addBankSummary()}
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </ModalWrapper>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default AddBankPaymentModal;
